import ProjectInvestmentBoard from './ProjectInvestmentBoard';

// Bucket B opt 1 — invest in licensed projects (for sale or rent), by area, with
// the current-investors strip on each project card.
export default function LicensedProjectsPage() {
  return (
    <ProjectInvestmentBoard
      variant="invest"
      icon="ri-building-3-line"
      titleEn="Invest in licensed projects"
      titleAr="الاستثمار في المشاريع المرخّصة"
      subtitleEn="Browse licensed projects for sale or rent by city, and see who's investing in each one."
      subtitleAr="تصفّح المشاريع المرخّصة للبيع أو الإيجار حسب المدينة، وشاهد من يستثمر في كل مشروع."
    />
  );
}
